import { withErrors } from "ra-remote-validator";
import React, { useMemo } from "react";
import { Create as RaCreate, usePermissions } from "react-admin";
import { compose } from "recompose";
import { useFormStyles } from "../components/forms/useStyles";
import Form from "./Form";

const Create = ({ dispatch, validate, errors, ...props }) => {
	const classes = useFormStyles();
	const { permissions } = usePermissions();
	const isAdmin = useMemo(
		() => permissions && permissions("admin"),
		[permissions]
	);
	return (
		<RaCreate {...props} classes={classes} redirect="list">
			<Form isAdmin={isAdmin} create={true} />
		</RaCreate>
	);
};

export default compose(withErrors)(Create);
